import { useContext, useEffect, useRef, useState } from 'react';
import { Building, BuildingDown, BuildingFill, BuildingFillUp, DoorOpen } from 'react-bootstrap-icons';
import { useClickOutside } from '../../components/Hooks/useClickOutside';
import Authentication from '../../libs/api/services/Authentication';
import User from '../../libs/api/services/User';
import CommonFunctionsContext from '../common/CommonFunctionsProvider';
export default function MenuFacilitiesSection() {
    const menuRef = useRef()
    const [expand, setExpand] = useState(false)

    useClickOutside(menuRef, () => { setExpand(false) })

    return (
        <div
            ref={menuRef}
            className='text-center text-light position-absolute w-100' style={{ left: '0px ' }}>
            <div onClick={e => {
                e.stopPropagation()
                setExpand(!expand)
            }
            }><b>
                    {expand ? <BuildingFillUp /> : <BuildingDown />}
                    {parseInt(Authentication.getFacility()) === -1 ? 'DrData' : Authentication.getFacilityName()}</b></div>
            {expand && <Facilities />}
        </div>)
}
const Facilities = () => {
    const { showConfirm } = useContext(CommonFunctionsContext)
    const [facilities, setFacilities] = useState([])
    const [facilitiesFltr, setFacilitiesFltr] = useState([])

    const searchRef = useRef()
    const _handleChangeFacility = async (facility) => {
        await Authentication.setFacility(facility, undefined)
        // navigate('/' + Authentication.getFacilityRole(), { state: nanoid() })
        // window.location.reload()
        // if (facility === -1 && role === -1)
        if (facility === -1)
            window.location = '/sys-admin'
        else
            window.location = '/Dashboard'
    }


    useEffect(() => {
        if (searchRef.current)
            searchRef.current.focus()

    }, [])

    useEffect(() => {
        const load = async () => {
            var fac_role = []
            for (const f of await Authentication.facilities()) {
                if (Object.keys(fac_role).includes(f.facility.facility))
                    fac_role[f.facility.facility].Roles.push(f.roles)
                else
                    fac_role[f.facility.facility] = { id: f.facility.id, Roles: [f.roles] }
            }
            // setFacilities(await Authentication.facilities())
            var _sorted = Object.keys(fac_role)
                .sort()
                .reduce((obj, key) => ({
                    ...obj, [key]: fac_role[key]
                }), {})
            if (_sorted[Object.keys(_sorted)[0]].Roles.find(x => x.role === 'System Admin'))
                _sorted = { "DrData": { id: -1, Roles: [{ id: -1, roles: "System Admin", preferedName: "Manage System" }] }, ..._sorted }
            setFacilities(_sorted)
            setFacilitiesFltr(_sorted)
        }
        load()
    }, [])

    const _handleFilter = (s) => {

        if (s === "")
            setFacilitiesFltr(facilities)
        else
            setFacilitiesFltr(Object.keys(facilities)
                .filter(key => key.toLowerCase().includes(s.toLowerCase()))
                .reduce((obj, key) => {
                    obj[key] = facilities[key]
                    return obj
                }, {}))
    }

    const _handleLeaveFacility = (facility) => {
        showConfirm({
            title: 'Revoke Facility',
            show: true,
            onCancel: () => { },
            onConfirm: () => User.UserRevokeFacility(facility).then(() =>
                Authentication.reloadFacilities().then(() => window.location = '/facilities')
            ),
            children: <div><p>You are about to leave a facility. Your clinicians will no longer be able to access your profile or assist you with Dr Data</p><p>Are you sure you would like to continue?</p></div>
        })
    }

    return (
        <div className='text-start w-100 shadow bg-primary-container position-relative' style={{ maxHeight: '30vh', zIndex: '100' }}>
            <input
                ref={searchRef}
                onClick={e => { e.stopPropagation() }}
                onChange={(e) => _handleFilter(e.target.value)} className='form-control form-control-sm' placeholder='Search' />
            <div style={{ maxHeight: 'calc(30vh - 50px)', overflow: 'auto' }}>
                {facilitiesFltr &&
                    Object.keys(facilitiesFltr).map((f) => <div key={f}>
                        <div className='d-flex align-items-center p-2'>
                            {parseInt(Authentication.getFacility()) === parseInt(facilitiesFltr[f].id) ? <BuildingFill /> : <Building />}
                            <div className="flex-grow-1" onClick={e => _handleChangeFacility(parseInt(facilitiesFltr[f].id))} >{f}</div>
                            <DoorOpen onClick={() => _handleLeaveFacility(parseInt(facilitiesFltr[f].id))} />
                        </div>
                    </div>)
                }
            </div>
        </div>
    )
}